import React from "react";
import style from "./RegisterSidebar.module.css";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import LogoMini from "@/assets/images/logo/logo-mini.svg";

import Icon from "@/ui/icon/Icon";

import Logo from "@/ui/logo/Logo";

function RegisterSidebar({ stepIndex }) {
	const { t } = useTranslation();
	const steps = [
		{
			name: t("auth:register.sidebar.steps.email"),
			icon: "fa-at",
		},
		{
			name: t("auth:register.sidebar.steps.confirm"),
			icon: "fa-envelopes",
		},
		{
			name: t("auth:register.sidebar.steps.details"),
			icon: "fa-user",
		},
		{
			name: t("auth:register.sidebar.steps.plan"),
			icon: "fa-tasks",
		},
	];

	return (
		<div className={style.sidebar}>
			<div className={style.header}>
				<Logo />
			</div>
			<div className={style.body}>
				<div className={style.steps}>
					{steps.map((step, index) => (
						<div
							key={index + 1}
							className={`${style.step} ${
								stepIndex == index + 1 ? style.active : ""
							} ${index + 1 < stepIndex ? style.done : ""}`}
						>
							<div className={style.icoHolder}>
								<Icon icon={step.icon} />
								{index + 1 < stepIndex && (
									<div className={style.check}>
										<Icon icon="fa-check" />
									</div>
								)}
							</div>
							<div className={style.info}>
								<span className={style.name}>{step.name}</span>
								<span className={style.description}>
									{t("auth:register.sidebar.step", {
										number: index + 1,
									})}
								</span>
							</div>
						</div>
					))}
				</div>
				<img
					className={style.logoBackground}
					src={LogoMini}
					alt={t("auth:register.sidebar.logoAlt")}
				/>
			</div>

			<div className={style.footer}>
				<div className={style.back}>
					<Icon icon="fa-arrow-left" />
					<Link to="/">{t("auth:register.sidebar.backHome")}</Link>
				</div>
				<div className={style.link}>
					<Link to="/login">{t("common:nav.login")}</Link>
				</div>
			</div>
		</div>
	);
}

export default RegisterSidebar;
